"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_router_dom_1 = require("react-router-dom");
var toPath_1 = __importDefault(require("./toPath"));
var getLocationPath = function (location) { return location.pathname + (location.search || ''); };
var getOriginPath = function (origin) { return typeof origin === 'string' ? origin : getLocationPath(origin); };
var normalizeTarget = function (target) { return typeof target === 'string' ? (0, toPath_1.default)(target) : target; };
var useNavigateWithOrigin = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var location = (0, react_router_dom_1.useLocation)();
    function navigateWithOrigin(target) {
        var _a;
        var origin = ((_a = location.state) === null || _a === void 0 ? void 0 : _a.from) || location;
        navigate(normalizeTarget(target), {
            state: { from: origin },
        });
    }
    function getStoredOrigin(fallback) {
        var _a;
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.from) {
            return getOriginPath(location.state.from);
        }
        return fallback;
    }
    return {
        navigateWithOrigin: navigateWithOrigin,
        getStoredOrigin: getStoredOrigin,
    };
};
exports.default = useNavigateWithOrigin;
